import React, { useState, useEffect } from "react";
import { Form, Button, Card, Row, Col, Select, Input, Checkbox, Radio, Divider, Tag, message } from "antd";
import { CloseOutlined, CheckOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import 'antd/dist/antd.css';
import PatronagerService from "../../../../../services/Election/Patronage/PatronagerService";
import { setFormFieldValue } from "../../../../../helpers/FormHelper";
import { capitalizeFirstLetter, lowerCaseString } from "../../../../../helpers/StringFormatter";


const { Option } = Select;

const rules = {
    political_preference: [
        {
            required: true,
            message: "Ju lutem, zgjidhni preferencën!",
        },
    ],
    safety: [
        {
            required: true,
            message: "Ju lutem, zgjidhni një nga opsionet e sigurisë së votuesit!",
        },
    ],
    country: [
        {
            required: true,
            message: "Ju lutem, zgjidhni shtetin e emigrimit!",
        }
    ],
    city: [
        {
            required: false,
            message: "Ju lutem, plotësoni qytetin në emigrim!",
        }
    ],
    address: [
        {
            required: false,
            message: "Ju lutem, plotësoni adresën në emigrim!",
        }
    ],
    zipCode: [
        {
            required: false,
            message: "Ju lutem, plotësoni kodin postar në emigrim!"
        }
    ],
    email: [
        {
            required: false,
            message: "Ju lutem, plotësoni emailin!",
        },
        {
            type: 'email',
            message: "Ju lutem jepni një email të vlefshëm!",
        }
    ]
};



const Edit = ({ item, politicalPreferences, countries, onSuccess, onBack }) => {
    const token = useSelector((state) => state.Member.token);
    const [form] = Form.useForm();
    const [checkedIsEmigrant, setIsEmigrantChecked] = useState(item?.is_emigrant);
    const [politicalPreferenceId, setPoliticalPreferenceId] = useState(item?.political_preference?.id);
    const [countryId, setCountryId] = useState(checkedIsEmigrant ? item?.emigrant_info?.country_emigrant?.id : null);
    const [voterSafety, setVoterSafety] = useState(item?.political_preference?.id ? item?.safety_rating : null);
    const [hasDocuments, setHasDocuments] = useState(item?.emigrant_info?.has_regular_documents ?? false);
    const [votesHere, setVotesHere] = useState(item?.emigrant_info?.votes_in_box ?? false);
    const [loading, setLoading] = useState(false);
    const fullName = item?.name + " " + item?.surname;
    const politicalPreference = setFormFieldValue(item?.political_preference?.name);
    const voterId = setFormFieldValue(item?.id);


    useEffect(() => {
        form.setFieldsValue({
            political_preference: item?.political_preference?.id,
            voter_safety: item?.political_preference?.id ? item?.safety_rating : null,
            is_emigrant: item?.is_emigrant,
            country: item?.is_emigrant ? item?.emigrant_info?.country_emigrant?.id : null,
            city: setFormFieldValue(item?.emigrant_info?.city),
            address: setFormFieldValue(item?.emigrant_info?.address),
            zipCode: setFormFieldValue(item?.emigrant_info?.zip_code),
            phone: item?.phone,
            email: item?.email,
            comment: item?.comment
        });
    }, [form, item]);


    const changeIsEmigrantChecked = (e) => {
        setIsEmigrantChecked(e.target.checked);
    };


    const changeVoterSafety = (e) => {
        setVoterSafety(e.target.value);
    };


    const politicalPreferenceHandler = (selectedValue) => {
        setPoliticalPreferenceId(selectedValue);
    };


    const countryHandler = (selectedValue) => {
        setCountryId(selectedValue);
    };


    const formatRequestData = (data) => {
        const requestData = {
            political_preference_id: setFormFieldValue(politicalPreferenceId),
            safety_rating: politicalPreferenceId ? setFormFieldValue(voterSafety) : null,
            is_emigrant: checkedIsEmigrant,
            country_emigrant_id: checkedIsEmigrant ? setFormFieldValue(countryId) : null,
            phone: setFormFieldValue(data.phone) ?? "",
            email: lowerCaseString(data.email) ?? "",
            comment: setFormFieldValue(data.comment) ?? "",
        }

        if (checkedIsEmigrant === true) {
            requestData.emigrant_city = capitalizeFirstLetter(data.city);
            requestData.emigrant_address = capitalizeFirstLetter(data.address) ?? ""; 
            requestData.emigrant_zipcode = setFormFieldValue(data.zipCode) ?? "";
            requestData.emigrant_has_documents = hasDocuments;
            requestData.emigrant_votes_in_box = votesHere;
        }

        return requestData;
    };


    const onSave = (e) => {
        setLoading(true);
        form
            .validateFields()
            .then((data) => {
                const requestData = formatRequestData(data);
                PatronagerService.updateVoterPartyDetails(token, requestData, voterId)
                    .then((response) => {
                        setLoading(false);
                        message.success("Ndryshimi u krye me sukses!", 1)
                            .then(() => onSuccess());
                    })
                    .catch((err) => {
                        const errorMessage = err.response.data.Error ? err.response.data.Error : "Një gabim ndodhi gjatë ndryshimit!";
                        message.error(errorMessage, 2).then(() => {
                            setLoading(false);
                        });
                    });
            })
            .catch((err) => {
                setLoading(false);
            });
    };


    const onHasDocumentsChange = (event) => {
        const isChecked = event.target.checked;
        setHasDocuments(isChecked);
    };


    const onVotesHereChange = (event) => {
        const isChecked = event.target.checked;
        setVotesHere(isChecked);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "15px" }}>
                            <Row gutter={24} align="middle">
                                <Col xl={4} lg={4} md={24} sm={24} xs={24}></Col>
                                <Col xl={16} lg={16} md={24} sm={24} xs={24} className="text-center">
                                    <h4 className="m-0 p-0">Jeni duke konsultuar votuesin e zgjedhur</h4>
                                </Col>
                                <Col xl={4} lg={4} md={24} sm={24} xs={24} className="text-center">
                                    <Button
                                        block
                                        ghost
                                        type="primary"
                                        // loading={submitLoading}
                                        onClick={onBack}
                                        icon={<ArrowLeftOutlined />}
                                        size="large"
                                    >
                                        Kthehu
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ backgroundColor: "#a461d836" }} className="text-center mt-2">
                            <h4 className="p-0 m-0" style={{ color: "#751fad" }}>{fullName}</h4>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card>
                            <Row gutter={24}>
                                <Col xl={1} lg={1} md={24} sm={24} xs={24}></Col>
                                <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Emri & Mbiemri:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {fullName}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Datëlindja:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {item?.birthdate}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Mosha:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {item?.age}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Telefoni:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {item?.phone}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Email:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {item?.email}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                </Col>
                                <Col xl={2} lg={2} md={14} sm={14} xs={14}></Col>
                                <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            QV:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {item?.qv_code}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Nr. listës:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {item?.list_number}
                                        </Col>

                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Kodi banesës:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            {item?.building_no}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            VHP:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>
                                            <Tag color={item?.first_time ? "purple" : "orange"}>{item?.first_time ? "PO" : "JO"}</Tag>
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                    <Row gutter={24}>
                                        <Col xl={10} lg={10} md={10} sm={10} xs={10} className="font-weight-bold">
                                            Preferenca:
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={14} xs={14} >
                                            {politicalPreference}
                                        </Col>
                                    </Row>
                                    <Divider className="w-100" style={{ marginTop: '10px', marginBottom: "10px" }} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card className="mt-2">
                            <Row gutter={24} className="mt-2">
                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form
                                        layout="horizontal"
                                        form={form}
                                        labelCol={{ span: 7 }}
                                        labelAlign="left"
                                    >
                                        <Row gutter={24}>
                                            <Col xl={5} lg={5} md={24} sm={24} xs={24} />
                                            <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                                                <Form.Item name="political_preference" label="Preferenca politike:" rules={rules.political_preference}>
                                                    <Select
                                                        className="w-100"
                                                        placeholder="-Zgjidhni preferencën-"
                                                        onChange={politicalPreferenceHandler}
                                                        allowClear
                                                    >
                                                        {politicalPreferences.map((elm) => (
                                                            <Option key={elm.id} value={elm.id}>
                                                                {elm.name}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item name="voter_safety" label="Siguria e votuesit:" rules={rules.safety}>
                                                    <Radio.Group onChange={changeVoterSafety} defaultValue={item?.safety_rating}>
                                                        <Radio value={1}>I sigurtë</Radio>
                                                        <Radio value={2}>I pa sigurtë</Radio>
                                                        <Radio value={3}>I lëkundur</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={24}>
                                            <Col span={24}>
                                                <Divider className="w-100 mt-1" />
                                            </Col>
                                        </Row>
                                        <Row gutter={24}>
                                            <Col xl={5} lg={5} md={24} sm={24} xs={24} />
                                            <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                                                <Form.Item name="is_emigrant" label="Emigrant:">
                                                    <Checkbox style={{ fontSize: "22px" }} checked={checkedIsEmigrant} onChange={changeIsEmigrantChecked} />
                                                </Form.Item>

                                                {checkedIsEmigrant && (
                                                    <Row gutter={24}>
                                                        <Col span={24}>
                                                            <Form.Item name="country" label="Shteti i emigrantit:" rules={rules.country}>
                                                                <Select
                                                                    className="w-100"
                                                                    placeholder="-Zgjidhni shtetin-"
                                                                    onChange={countryHandler}
                                                                    allowClear
                                                                >
                                                                    {countries.map((elm) => (
                                                                        <Option key={elm.id} value={elm.id}>
                                                                            {elm.country_name}
                                                                        </Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                            <Form.Item name="city" label="Qyteti në emigrim" rules={rules.city}>
                                                                <Input type="text" placeholder="Qyteti..." />
                                                            </Form.Item>
                                                            <Form.Item name="address" label="Adresa në emigrim" rules={rules.address}>
                                                                <Input.TextArea rows={2} type="text" placeholder="Adresa..." />
                                                            </Form.Item>
                                                            <Form.Item name="zipCode" label="Kodi postar në emigrim" rules={rules.zipCode}>
                                                                <Input type="text" placeholder="Kodi postar..." />
                                                            </Form.Item>
                                                            <Form.Item name="hasDocuments" label="Me dokumenta të rregullt">
                                                                <Checkbox style={{ fontSize: "22px" }} checked={hasDocuments} onChange={onHasDocumentsChange} />
                                                            </Form.Item>
                                                            <Form.Item name="votesHere" label="Voton në kuti">
                                                                <Checkbox style={{ fontSize: "22px" }} checked={votesHere} onChange={onVotesHereChange} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                )}

                                            </Col>
                                        </Row>
                                        <Row gutter={24}>
                                            <Col span={24}>
                                                <Divider className="w-100 mt-1" />
                                            </Col>
                                        </Row>
                                        <Row gutter={24}>
                                            <Col xl={5} lg={5} md={24} sm={24} xs={24} />
                                            <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                                                <Form.Item name="phone" label="Telefoni:">
                                                    <Input type="text" placeholder="Telefoni..." />
                                                </Form.Item>
                                                <Form.Item name="email" label="Email:" rules={rules.email}>
                                                    <Input type="text" placeholder="Email..." />
                                                </Form.Item>
                                                <Divider className="w-100" />
                                                <Form.Item name="comment" label="Komente:">
                                                    <Input.TextArea type="text" rows={4} />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <Divider className="w-100 mt-1" />
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="text-center mt-3">
                                    <Button
                                        type="primary"
                                        className="mr-4"
                                        onClick={onSave}
                                        style={{ width: '150px', height: "40px" }}
                                        loading={loading}
                                        icon={<CheckOutlined />}
                                        size="large"
                                    >
                                        Ruaj
                                    </Button>
                                    <Button
                                        danger
                                        onClick={onBack}
                                        style={{ width: '150px', height: "40px" }}
                                        icon={<CloseOutlined />}
                                        size="large"
                                    >
                                        Dil
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row >
            </Col >
        </Row >
    );
};


export default Edit;